"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const react_1 = __importStar(require("react"));
const dom_1 = require("@floating-ui/dom");
const react_dom_1 = require("react-dom");
const ReactTooltip_1 = require("./ReactTooltip");
function Dropdown({ trigger = react_1.default.createElement("i", { className: "fa fa-ellipsis-vertical me-2" }), placement = "bottom-end", className = "btn-primary dropdown-toggle", children }) {
    const [show, setShow] = (0, react_1.useState)(false);
    const ref = (0, react_1.useRef)();
    const menuRef = (0, react_1.useRef)();
    const width = (0, ReactTooltip_1.useWindowWidth)();
    (0, react_1.useEffect)(function () {
        if (!show)
            return;
        function onclick(e) {
            var _a;
            if (e.target == menuRef.current || ((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                setTimeout(() => setShow(false), 30);
                return;
            }
            setShow(false);
        }
        (0, dom_1.computePosition)(ref.current, menuRef.current, {
            strategy: 'absolute',
            placement,
            middleware: [
                (0, dom_1.offset)(8), (0, dom_1.flip)(),
                (0, dom_1.shift)({ padding: 10, crossAxis: false, limiter: (0, dom_1.limitShift)({ offset: 10, }) })
            ]
        }).then(({ x, y }) => {
            if (menuRef.current == null)
                return;
            Object.assign(menuRef.current.style, {
                left: `${x}px`,
                top: `${y}px`,
                visibility: 'visible'
            });
        });
        document.addEventListener('click', onclick, true);
        return () => { document.removeEventListener('click', onclick, true); };
    }, [width, show]);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "dropdown d-inline-block" },
            react_1.default.createElement("button", { ref: ref, className: `btn ${className}`, type: "button", onClick: () => setShow(!show) }, trigger),
            show && (0, react_dom_1.createPortal)(react_1.default.createElement("ul", { ref: menuRef, className: "dropdown-menu show" }, children), document.body)));
}
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map